const UnlockScreen = () => null;

export default UnlockScreen;
